import { useMutation } from 'react-query'
import { toggleGroupLock } from '@services/requests/friendGroups'

export const useMutateFriendGroupLocked = (groupId: string) => {
  return useMutation((locked: boolean) => {
    return toggleGroupLock(groupId, locked)
  })
}
